import { getGraphqlClient } from "@lib/graphql-client"
import { useMutation } from "@tanstack/react-query"

export type SignupFormValues = {
  firstName: string
  lastName: string
  email: string
  password: string
  repeatPassword: string
  foundViesusThrough: string
  preferences?: Record<string, boolean>
}

const { sdk } = getGraphqlClient()
export function useSignupMutation() {
  return useMutation({
    mutationFn: async (args: SignupFormValues) =>
      sdk.Signup({
        input: {
          firstName: args.firstName,
          lastName: args.lastName,
          email: args.email,
          password: args.password,
          url: `${window.location.origin}/signup/confirm-email`,
          foundViesusThrough: args.foundViesusThrough,
          secret: "asfd21421fdsandjspX2nU0MNulmP9PLnG3hJaSfDasfas",
          preferences: args.preferences,
        },
      }),
  })
}
